import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

// Layouts
import MainLayout from "../layouts/MainLayout";
// import ErrorLayout from "../layouts/ErrorLayout";

// Error Layouts
// import Error404 from "components/SuccessErrorsPages/Error404";
// import Error500 from "components/SuccessErrorsPages/Error500";
// import Success from "components/SuccessErrorsPages/SuccessPage";
// import Failure from "components/SuccessErrorsPages/FailurePage";
// import Error403 from "components/SuccessErrorsPages/Error403";
import CardLogin from "components/authentication/card/Login";
import HomePage from "components/HomePage/HomePage";
import FeatureManagement from "components/Modules/Modules";
//Landing
import LandingPage from "components/LandingPage/Landing";
import XSurvey from "components/dashboards/XSurvey/dashboard"
// QA Dashboard - Commented out as components don't exist yet
// import Overall from "components/dashboards/QADashboard/OverallView/Overall";
// import TeamGroup from "components/dashboards/QADashboard/TeamGroupView/TeamGroup";
// import Ticket from "components/dashboards/QADashboard/TicketView/Ticket";
// import Agent from "components/dashboards/QADashboard/AgentView/Agent";
import ZendeskCallbackHandler from "components/authentication/ZendeskCallbackHandler";
import ProtectedRoute from "components/common/ProtectedRoute";

const FalconRoutes = () => {
  return (
    <Routes>
      {/* <Route element={<ErrorLayout />}>
        <Route path="/errors/404" element={<Error404 />} />
        <Route path="/errors/500" element={<Error500 />} />
        <Route path="/errors/403" element={<Error403 />} />
      </Route>
      <Route path="/success" element={<Success />} />
      <Route path="/failure" element={<Failure />} /> */}

      {/*------------------------------------------MainLayout------------------------------------------*/}

      <Route path="/" element={<HomePage />} />

      <Route path="/zendesk-callback" element={<ZendeskCallbackHandler />} />
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        {/* landing page */}
        <Route path="/landingpage" element={<LandingPage />} />
        {/* <Route path="/errors/404" element={<LandingPage />} /> */}
        {/* QA */}
        <Route path="/dashboard" element={<XSurvey id={"xsurvey"} />} />

        <Route path="/settings" element={<FeatureManagement />} />

      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
